import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { Rights } from "../../Enums/Rights";
import { Roles } from "../../Enums/Roles";

const useStyles = makeStyles({});

export default function PermissionForm({ roleId, roleRights, setRoleRights }) {
  const classes = useStyles();
  const [tenants, setTenants] = useState(false);
  const [clients, setClients] = useState(false);
  const [users, setUsers] = useState(false);
  const [configurations, setConfigurations] = useState(false);
  const [events, setEvents] = useState(false);
  const [eventTypes, setEventTypes] = useState(false);
  const [eventVenues, setEventVenues] = useState(false);
  const [eventSponsors, setEventSponsors] = useState(false);
  const [featuredJobs, setFeaturedJobs] = useState(false);
  const [prefilteredLinks, setPrefilteredLinks] = useState(false);
  const [talentNetworkData, setTalentNetworkData] = useState(false);
  const [locations, setLocations] = useState(false);
  const [resumes, setResumes] = useState(false);
  const [connectBillings, setConnectBillings] = useState(false);

  const changeRoleRights = (e, value, set) => {
    if (e.target.checked) {
      setRoleRights(roleRights + value);
    } else {
      setRoleRights(roleRights - value);
    }
    set(e.target.checked);
  };

  useEffect(() => {
    const flagVals = [
      [Rights.ConnectBillings, setConnectBillings],
      [Rights.Resumes, setResumes],
      [Rights.Locations, setLocations],
      [Rights.TalentNetworkData, setTalentNetworkData],
      [Rights.PrefilteredLinks, setPrefilteredLinks],
      [Rights.FeaturedJobs, setFeaturedJobs],
      [Rights.EventSponsors, setEventSponsors],
      [Rights.EventVenues, setEventVenues],
      [Rights.EventTypes, setEventTypes],
      [Rights.Events, setEvents],
      [Rights.Configurations, setConfigurations],
      [Rights.Users, setUsers],
      [Rights.Clients, setClients],
      [Rights.Tenants, setTenants],
    ];
    var rightsDisplay = roleRights;
    for (let val in flagVals) {
      if (rightsDisplay - flagVals[val][0] >= 0) {
        flagVals[val][1](true);
        rightsDisplay = rightsDisplay - flagVals[val][0];
      }
    }
  }, [roleRights]);

  if (roleId !== "") {
    return (
      <FormControl component="fieldset" className={classes.formControl}>
        {roleId !== Roles.SuperAdmin ? (
          <FormLabel component="legend">Additonal Rights</FormLabel>
        ) : null}
        <FormGroup>
          {roleId !== Roles.SuperAdmin ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={clients}
                  onChange={(e) =>
                    changeRoleRights(e, Rights.Clients, setClients)
                  }
                />
              }
              label="Manage Clients"
            />
          ) : null}
          {roleId !== Roles.SuperAdmin &&
          roleId !== Roles.ClientAdmin &&
          roleId !== Roles.Admin ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={configurations}
                  onChange={(e) =>
                    changeRoleRights(
                      e,
                      Rights.Configurations,
                      setConfigurations
                    )
                  }
                />
              }
              label="Manage Configurations"
            />
          ) : null}
          {roleId !== Roles.SuperAdmin &&
          roleId !== Roles.ConnectBillingsAdmin ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={connectBillings}
                  onChange={(e) =>
                    changeRoleRights(
                      e,
                      Rights.ConnectBillings,
                      setConnectBillings
                    )
                  }
                />
              }
              label="Manage Connect Billings"
            />
          ) : null}
          {roleId !== Roles.LightAdmin &&
          roleId !== Roles.SuperAdmin &&
          roleId !== Roles.ClientAdmin &&
          roleId !== Roles.Admin &&
          roleId !== Roles.EventsManager ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={eventSponsors}
                  onChange={(e) =>
                    changeRoleRights(e, Rights.EventSponsors, setEventSponsors)
                  }
                />
              }
              label="Manage Event Sponsors"
            />
          ) : null}
          {roleId !== Roles.LightAdmin &&
          roleId !== Roles.SuperAdmin &&
          roleId !== Roles.ClientAdmin &&
          roleId !== Roles.Admin &&
          roleId !== Roles.EventsManager ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={eventTypes}
                  onChange={(e) =>
                    changeRoleRights(e, Rights.EventTypes, setEventTypes)
                  }
                />
              }
              label="Manage Event Types"
            />
          ) : null}
          {roleId !== Roles.LightAdmin &&
          roleId !== Roles.SuperAdmin &&
          roleId !== Roles.ClientAdmin &&
          roleId !== Roles.Admin &&
          roleId !== Roles.EventsManager ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={eventVenues}
                  onChange={(e) =>
                    changeRoleRights(e, Rights.EventVenues, setEventVenues)
                  }
                />
              }
              label="Manage Event Venues"
            />
          ) : null}
          {roleId !== Roles.LightAdmin &&
          roleId !== Roles.SuperAdmin &&
          roleId !== Roles.ClientAdmin &&
          roleId !== Roles.Admin &&
          roleId !== Roles.EventsManager ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={events}
                  onChange={(e) =>
                    changeRoleRights(e, Rights.Events, setEvents)
                  }
                />
              }
              label="Manage Events"
            />
          ) : null}
          {roleId !== Roles.LightAdmin &&
          roleId !== Roles.SuperAdmin &&
          roleId !== Roles.JobsManager &&
          roleId !== Roles.ClientAdmin &&
          roleId !== Roles.Admin ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={featuredJobs}
                  onChange={(e) =>
                    changeRoleRights(e, Rights.FeaturedJobs, setFeaturedJobs)
                  }
                />
              }
              label="Manage Featured Jobs"
            />
          ) : null}
          {roleId !== Roles.SuperAdmin && roleId !== Roles.Admin ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={locations}
                  onChange={(e) =>
                    changeRoleRights(e, Rights.Locations, setLocations)
                  }
                />
              }
              label="Manage Locations"
            />
          ) : null}
          {roleId !== Roles.TalentNetworkManager &&
          roleId !== Roles.LightAdmin &&
          roleId !== Roles.SuperAdmin &&
          roleId !== Roles.JobsManager &&
          roleId !== Roles.ClientAdmin &&
          roleId !== Roles.Admin &&
          roleId !== Roles.EventsManager ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={prefilteredLinks}
                  onChange={(e) =>
                    changeRoleRights(
                      e,
                      Rights.PrefilteredLinks,
                      setPrefilteredLinks
                    )
                  }
                />
              }
              label="Manage Prefiltered Links"
            />
          ) : null}
          {roleId !== Roles.SuperAdmin ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={resumes}
                  onChange={(e) =>
                    changeRoleRights(e, Rights.Resumes, setResumes)
                  }
                />
              }
              label="Manage Resumes"
            />
          ) : null}
          {roleId !== Roles.SuperAdmin &&
          roleId !== Roles.ClientAdmin &&
          roleId !== Roles.Admin &&
          roleId !== Roles.TalentNetworkManager &&
          roleId !== Roles.LightAdmin ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={talentNetworkData}
                  onChange={(e) =>
                    changeRoleRights(
                      e,
                      Rights.TalentNetworkData,
                      setTalentNetworkData
                    )
                  }
                />
              }
              label="Manage Talent NetWork Data"
            />
          ) : null}
          {roleId !== Roles.SuperAdmin ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={tenants}
                  onChange={(e) =>
                    changeRoleRights(e, Rights.Tenants, setTenants)
                  }
                />
              }
              label="Manage Tenants"
            />
          ) : null}
          {roleId !== Roles.LightAdmin &&
          roleId !== Roles.SuperAdmin &&
          roleId !== Roles.Admin ? (
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={users}
                  onChange={(e) => changeRoleRights(e, Rights.Users, setUsers)}
                />
              }
              label="Manage Users"
            />
          ) : null}
        </FormGroup>
      </FormControl>
    );
  } else {
    return null;
  }
}
